import uuid from 'uuid-random';

export const SINGLETON_MODE = {
    PERSIST: 'PERSIST', // use first added popup instance
    UPDATE: 'UPDATE' // update (replace) popup instance each time new popup is added
};

export const POPUP_IDS = {
    PLAYER_SELF_EXCLUDE_LOGGED_OFF: uuid(),
    PLAYER_FREEZE_ACCOUNT_POPUP: uuid(),
    LOGOUT_NOTIFICATION_POPUP: uuid(),
    USER_VERIFY_POPUP: uuid()
};

// mapping of popup ids to template ids from pushes (e.g. 31133, 31026)
export const POPUP_TEMPLATE_IDS = {
    [POPUP_IDS.PLAYER_FREEZE_ACCOUNT_POPUP]: 'player_freeze_account',
    [POPUP_IDS.PLAYER_SELF_EXCLUDE_LOGGED_OFF]: 'rg_selfexclude_player_logged_off'
};
